<!-- TEMPLATE -->
<template>
    <v-layout wrap justify-center align-center>
        <v-flex>
            <v-card class="elevation-1">
                <v-list dense two-line>
                    <template v-for="(draft, index) in filteredDrafts">
                        <v-list-tile :key="'draft-'+title+'-'+index">
                            <v-flex xs3 sm2>
                                <v-list-tile-content>
                                    <v-list-tile-title>{{draft.teams.blue.tag}} - {{draft.teams.red.tag}}
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title>{{getWinnerTag(draft)}} win</v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-flex>
                            <v-flex hidden-xs-only xs4>
                                <v-list-tile-content>
                                    <!-- <v-list-tile-title>{{draft.teams.blue.tag}}</v-list-tile-title> -->
                                    <v-list-tile-sub-title>
                                        <v-avatar class="champion" tile v-for="champion in draft.teams.blue.picks" v-on:click="selectChampion(champion)" :size="championIconSize" :key="'blue-pick-'+champion">
                                            <img :class="greyChampion(champion)" v-bind:src="'https://ddragon.leagueoflegends.com/cdn/'+version+'/img/champion/'+ champions[champion].image.full">
                                        </v-avatar>
                                    </v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-flex>
                            <v-flex hidden-xs-only xs4>
                                <v-list-tile-content>
                                    <!-- <v-list-tile-title>{{draft.teams.red.tag}}</v-list-tile-title> -->
                                    <v-list-tile-sub-title>
                                        <v-avatar class="champion" tile v-for="champion in draft.teams.red.picks" v-on:click="selectChampion(champion)" :size="championIconSize" :key="'red-pick-'+champion">
                                            <img :class="greyChampion(champion)" v-bind:src="'https://ddragon.leagueoflegends.com/cdn/'+version+'/img/champion/'+ champions[champion].image.full">
                                        </v-avatar>
                                    </v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-flex>
                            <v-spacer></v-spacer>
                            <v-flex xs1>
                                <v-list-tile-action v-if="draft.watchUrl || draft.youtubeId">
                                    <v-tooltip bottom v-if="draft.youtubeId && !draft.watchUrl">
                                        <v-btn :href="'https://www.youtube.com/watch?v='+draft.youtubeId" slot="activator" icon ripple>
                                            <v-icon color="grey lighten-1">play_circle_filled
                                            </v-icon>
                                        </v-btn>
                                        <span>Watch on Youtube</span>
                                    </v-tooltip>
                                    <v-tooltip bottom v-if="draft.watchUrl">
                                        <v-btn :href="'https://watch.'+userRegion+'.lolesports.com/vod/'+draft.watchUrl" slot="activator" icon ripple>
                                            <v-icon color="grey lighten-1">play_circle_filled
                                            </v-icon>
                                        </v-btn>
                                        <span>Watch on lolesport</span>
                                    </v-tooltip>
                                </v-list-tile-action>
                            </v-flex>
                            <v-spacer></v-spacer>
                            <v-flex xs1>
                                <v-list-tile-action v-if="draft.matchHistory">
                                    <v-tooltip bottom>
                                        <v-btn :href="draft.matchHistory" slot="activator" icon ripple>
                                            <v-icon color="grey lighten-1">timeline
                                            </v-icon>
                                        </v-btn>
                                        <span>Match History</span>
                                    </v-tooltip>
                                </v-list-tile-action>
                            </v-flex>
                            <v-spacer></v-spacer>
                            <v-list-tile-action>
                                <v-list-tile-action-text>{{parseGameDate(draft.date)}}</v-list-tile-action-text>
                                <v-list-tile-action-text>Patch {{parseGameVersion(draft.gameVersion)}}</v-list-tile-action-text>
                            </v-list-tile-action>
                        </v-list-tile>
                        <v-divider v-if="index + 1 < filteredDrafts.length" :key="index+'_draftDivider'"></v-divider>
                    </template>
                </v-list>
            </v-card>
        </v-flex>
    </v-layout>
</template>
<!-- SCRIPT -->
<script>
import champions from "../../assets/data/champions.json"
import moment from 'moment'

export default {
    name: 'Drafts',
    props: {
        drafts: Array,
        title: String
    },
    data: function() {
        return {
            selectedChampions: [],
            champions: champions.data,
            version: champions.version
        }
    },
    methods: {
        parseGameVersion: function(version) {
            return version.substring(0, version.indexOf(".", 2))
        },
        parseGameDate: function(timestamp) {
            return moment(timestamp).format("MMM Do")
        },
        selectTeam: function(tag) {
            if (this.selectedTeams.indexOf(tag) >= 0) {
                this.selectedTeams.splice(this.selectedTeams.indexOf(tag), 1);
            } else this.selectedTeams.push(tag);
        },
        selectChampion: function(championId) {
            if (this.selectedChampions.indexOf(championId) >= 0) {
                this.selectedChampions.splice(this.selectedChampions.indexOf(championId), 1);
            } else this.selectedChampions.push(championId);
        },
        greyTeam: function(tag) {
            if (this.selectedTeams.length) {
                return this.selectedTeams.indexOf(tag) < 0 ? "filter-grey" : "";
            } else return "";
        },
        greyChampion: function(championId) {
            if (this.selectedChampions.length) {
                return this.selectedChampions.indexOf(championId) < 0 ? "filter-grey" : "highlight";
            } else return "";
        },
        getWinnerTag: function(draft) {
            return draft.teams.blue.win ? draft.teams.blue.tag : draft.teams.red.tag
        }
    },
    computed: {
        filteredDrafts: function() {
            return this.drafts;
        },
        championIconSize: function() {
            return window.innerWidth >= 960 ? 40 : 34;
        },
        userRegion: function() {
            return navigator.language == 'en-US' ? 'na' : 'euw';
        }
    }
}
</script>
<!-- STYLE -->
<style scoped>
img.filter-grey {
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
    opacity: 0.8;
}

.champion {
    cursor: pointer;
}
</style>